import React, { useState } from "react";
import { BiX, BiDownload, BiFile, BiTable } from "react-icons/bi";

const ExportModal = ({ onClose, onExport }) => {
  const [format, setFormat] = useState("csv");
  const [includeFilters, setIncludeFilters] = useState(true);
  const [includeSummary, setIncludeSummary] = useState(true);
  const [isExporting, setIsExporting] = useState(false);

  const formats = [
    {
      id: "csv",
      label: "CSV",
      icon: <BiFile size={20} />,
      description: "Format universel, compatible avec Excel",
    },
    {
      id: "excel",
      label: "Excel",
      icon: <BiTable size={20} />,
      description: "Fichier Excel avec mise en forme",
    },
    {
      id: "pdf",
      label: "PDF",
      icon: <BiDownload size={20} />,
      description: "Document PDF imprimable",
    },
  ];

  const handleExport = async () => {
    setIsExporting(true);
    try {
      await onExport(format, { includeFilters, includeSummary });
      onClose();
    } catch (error) {
      console.error("Erreur export:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-md w-full mx-4">
        {/* En-tête */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="font-poppins font-semibold text-[18px] text-title">
            Exporter le rapport
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <BiX size={24} />
          </button>
        </div>

        {/* Corps */}
        <div className="p-6 space-y-6">
          {/* Format */}
          <div>
            <label className="block font-nunito font-semibold text-[14px] text-text mb-3">
              Format d'export
            </label>
            <div className="space-y-3">
              {formats.map((f) => (
                <label
                  key={f.id}
                  className={`
                    flex items-start p-3 border rounded-lg cursor-pointer transition-colors
                    ${
                      format === f.id
                        ? "border-secondary-500 bg-secondary-50"
                        : "border-gray-200 hover:bg-gray-50"
                    }
                  `}
                >
                  <input
                    type="radio"
                    name="format"
                    value={f.id}
                    checked={format === f.id}
                    onChange={(e) => setFormat(e.target.value)}
                    className="sr-only"
                  />
                  <div className="flex items-start gap-3">
                    <div
                      className={`mt-0.5 ${format === f.id ? "text-secondary-600" : "text-gray-400"}`}
                    >
                      {f.icon}
                    </div>
                    <div>
                      <p className="font-nunito font-medium text-[14px] text-text">
                        {f.label}
                      </p>
                      <p className="font-nunito text-[12px] text-gray-500">
                        {f.description}
                      </p>
                    </div>
                  </div>
                </label>
              ))}
            </div>
          </div>

          {/* Options */}
          <div>
            <label className="block font-nunito font-semibold text-[14px] text-text mb-3">
              Options
            </label>
            <div className="space-y-2">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={includeFilters}
                  onChange={(e) => setIncludeFilters(e.target.checked)}
                  className="rounded border-gray-300 text-secondary-500 focus:ring-secondary-500"
                />
                <span className="font-nunito text-[14px] text-text">
                  Inclure les filtres appliqués
                </span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={includeSummary}
                  onChange={(e) => setIncludeSummary(e.target.checked)}
                  className="rounded border-gray-300 text-secondary-500 focus:ring-secondary-500"
                />
                <span className="font-nunito text-[14px] text-text">
                  Inclure le résumé/KPIs
                </span>
              </label>
            </div>
          </div>
        </div>

        {/* Pied */}
        <div className="p-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            disabled={isExporting}
          >
            Annuler
          </button>
          <button
            onClick={handleExport}
            disabled={isExporting}
            className="flex items-center gap-2 px-4 py-2 text-sm bg-secondary-500 text-white rounded-lg hover:bg-secondary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isExporting ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Export en cours...
              </>
            ) : (
              <>
                <BiDownload size={16} />
                Exporter
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportModal;
